import formatFixedNumber from './formatFixedNumber'

const formatCurrency = (amount, decimals = 2) => {
  // A missing price arrives as null, undefined, or NaN. Without this guard
  // Math.abs turns it into "$NaN" (or "$0.00" for null) instead of "N/A".
  if (amount == null || !Number.isFinite(Number(amount))) {
    return formatFixedNumber(undefined, decimals)
  }

  const costAsCurrency = `$${formatFixedNumber(Math.abs(amount), decimals)}`

  return amount < 0 ? `(${costAsCurrency})` : costAsCurrency
}

export default formatCurrency
